/***
 * 进入路由前的操作
 */

// 默认
export const route = {
  redirect: '/home/lh'
};

// 验证是否允许访问
export const validate = [
  {
    name: '检测用户是否登录',
    async handle() {
      const store = this.$store;
      await store.dispatch('root/getUserInfo');
      // 未登录
      if (!store.state.root.user.uid) {
        this.$router.replace('/login?path=' + encodeURIComponent(`${location.pathname}${location.search}`));
        return true;
      }
    }
  }
];

export const tasks = [
  [
    {
      name: '获取首页tab',
      handle() {
        return this.$store.dispatch('home/fetchHeadTabs');
      }
    },
    // {
    //   name: '获取投注记录',
    //   handle() {
    //     return this.$store.dispatch('home/getLotteryLatest');
    //   }
    // },
    {
      name: '获取通知数据',
      handle() {
        return this.$store.dispatch('home/getNotices');
      }
    }
  ]
];



// WEBPACK FOOTER //
// ./src/pages/home/index.js